import { render, staticRenderFns } from "./coins_table.vue?vue&type=template&id=0a88f97b&"
import script from "./coins_table.vue?vue&type=script&lang=js&"
export * from "./coins_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports